module.exports = __webpack_public_path__ + "static/media/2_en.37af2b5d.png";